import { IConveyorBoxItemUI } from "../../lib/interfaces/ConveyorBox/IConveyorBox";
import useVerifyItems from "./useVerifyItems";
import { useDispatch } from "react-redux";
import {
  autoVerifyAllItems,
  autoVerifyQuantity,
  resetAllVerifiedItemQuantity,
  verifyBoxItem,
  unverifyBoxItem, 
} from "../../lib/store/reducers/conveyorBoxReviewReducer";
import { addMessage } from "../../lib/store/reducers/responseMessagesReducer";
import { setIsScanDisabled } from "../../lib/store/reducers/controlAppStateReducer";

interface UseVerifyItemsOptions {
  items: IConveyorBoxItemUI[];
}

const useVerifyItemsA2 = ({ items }: UseVerifyItemsOptions) => {
  const dispatch = useDispatch();
  const {
    onVerifyItemByBarcode,
    onVerifyItemById,
    onAutoVerifyQuantity,
    onResetAllVerifiedQuantity,
    isAllItemsVerified,
    onAutoVerifyQuantityAll,
    onVerifyRxBagByBarcode,
    onUnverifyItemById,
  } = useVerifyItems({
    items: items,
    dispatch,
    actions: {
      verifyBoxItem,
      autoVerifyQuantity,
      resetAllVerifiedItemQuantity,
      autoVerifyAllItems,
      addMessage,
      setIsScanDisabled,
      unverifyBoxItem,
    },
  });
  return {
    onVerifyItemByBarcode,
    onVerifyItemById,
    onAutoVerifyQuantity,
    onResetAllVerifiedQuantity,
    isAllItemsVerified,
    onAutoVerifyQuantityAll,
    onVerifyRxBagByBarcode,
    onUnverifyItemById,
  };
};

export default useVerifyItemsA2;
